var _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 82,
    height: 82,
    rx: 8,
    fill: "#1A5958",
    stroke: "black",
    strokeWidth: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 67.7966,
    height: 67.7966,
    fill: "url(#pattern0_100_584)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_100_584",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_100_584",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_100_584",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxx);
export default __webpack_public_path__ + "static/media/boxx.db5a33df757a446057ebb79dc811672f.svg";
export { ForwardRef as ReactComponent };